import { render, staticRenderFns } from "./TimelineBasicPerekomendasi.vue?vue&type=template&id=48639352"
import script from "./TimelineBasicPerekomendasi.vue?vue&type=script&lang=js"
export * from "./TimelineBasicPerekomendasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports